module.exports = __webpack_public_path__ + "static/img/no-data.21c1f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-data.png
// module id = dotK
// module chunks = 11